import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"back\"><path d=\"M0 6.945 6.459 0l1.453 1.563-5.006 5.382L8 12.437 6.547 14 0 6.945Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol